module.exports = __webpack_public_path__ + "static/media/Distrito-10.7bad0453.png";